import { useNavigate, useParams } from "react-router-dom";
import { useCentralStore } from "../../store/Central";
import { useJobStore } from "../../store/Jobs";
import { useCallback, useMemo } from "react";
import { ChatComponent } from "../../components/chat/chat.component";
import { JobRequestCustomV1 } from "@/lib/store/Realtime/message.types";

export const ClientJobRequestPage: React.FC = () => {
	const navigate = useNavigate();
	const { channelId } = useParams<{ clientId: string; channelId: string }>();
	const { organization, userId, clients } = useCentralStore((state) => ({
		organization: state.organization,
		userId: state.profile?.id,
		clients: Object.values(state.clientsLookup),
	}));
	const { shareFile, unshareFile, acceptJobRequest, denyJobRequest } =
		useJobStore((state) => ({
			shareFile: state.shareFile,
			unshareFile: state.unshareFile,
			acceptJobRequest: state.acceptJobRequest,
			denyJobRequest: state.denyJobRequest,
		}));

	const clientOrganizationIds = useMemo(() => {
		return clients
			.map((client) => client.connected_organization_id)
			.filter((id): id is string => id !== null);
	}, [clients]);

	const handleAcceptJobRequest = useCallback(
		async (
			channelId: string | null,
			messageContent?: JobRequestCustomV1 | null
		) => {
			const result = await acceptJobRequest(channelId, messageContent);
			if (result.success) {
				navigate(`/client/${result.clientId}/job/${result.jobId}`);
			}
			return result;
		},
		[acceptJobRequest, navigate]
	);

	if (!organization?.id || !userId || !channelId) {
		return <div></div>;
	}

	return (
		<div className="h-full flex">
			<div className="flex-1 bg-white">
				<ChatComponent
					organizationId={organization.id}
					channelId={channelId}
					onShareFile={shareFile}
					onUnshareFile={unshareFile}
					onAcceptJobRequest={handleAcceptJobRequest}
					onDenyJobRequest={denyJobRequest}
					clientOrganizationIds={clientOrganizationIds}
					allowGoTo={true}
					checkForClientConnectionToCustomer={true}
				/>
			</div>
		</div>
	);
};
